export default "__VITE_ASSET__Co79yUzM__"